<div id="poll-container" [ngClass]="isMobile ? 'poll-container-mob mt-10' : 'mt-10'">
  <div class="header w-full p-20" style="position: relative;">
    <div class="flex-row content-between align-items-center">
      <div *ngIf="poll.image && poll.image.length > 0" class="sphere-background">
        <img [src]="poll.image" alt="User Icon" class="user-icon">
      </div>

      <div *ngIf="!isTestModeActive else testModeActiveTemplate" class="w-three-quarters">
        <p class="yellow no-margin">LE VOTE EST OUVERT</p>
        <h2 class="white bold" style="letter-spacing: 2.88px;">EXPRIMEZ-VOUS MAINTENANT !</h2>
      </div>
      <ng-template #testModeActiveTemplate>
        <div class="w-three-quarters">
          <h1 class="yellow bold" style="letter-spacing: 2.88px; font-family: 'Roboto', sans-serif;">ESPACE DE TEST</h1>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="text-center">
    <div *ngIf="(firstname != 'New' && lastname != 'Voter') &&
            (firstname != null); else emailBlock" class="text-center">
      <h3 class="bold dark-blue no-margin text-xl">{{firstname}} {{lastname}}</h3>
    </div>
    <ng-template #emailBlock>
      <div class="text-center">
        <h3 class="bold dark-blue no-margin text-xl">{{email}}</h3>
      </div>
    </ng-template>
    <div *ngIf="availableElections()">
      <p class="dark-blue no-margin text-sm" *ngIf="electionSelected == -1 && !isTestModeActive">
        Participez dès maintenant au scrutin
      </p>
      <p class="dark-blue no-margin text-sm" *ngIf="electionSelected == -1 && !isTestModeActive">
        C’est le moment de faire entendre votre voix !
      </p>
    </div>

  </div>

  <div class="info-card w-three-quarters">
    <h1 class="bold dark-blue no-margin text-xl">"{{poll?.name}}"</h1>
    <p class="text-md dark-blue no-margin" *ngIf="poll.rounds.length > 0 && poll.rounds[0].college != null">Collège {{poll.rounds[0].college}} {{poll.rounds[0].collegeName}}</p>
    <p class="text-md dark-blue no-margin">Ouvert jusqu’au {{endDate}}.</p>
  </div>

  <!-- <div class="text-center">
    <a class="blockchain-link" href="{{blockchainUrl}}" target="_blank" rel="noopener noreferrer">
      <img src="assets/download-icon.svg" alt="audit-icon" class="icon">Urne transparente décentralisée (Blockchain)
    </a>
  </div> -->

  <app-suspend-popup class="popup-suspended" *ngIf="poll && poll.suspended else ongoing" title="{{poll.name}}"
    endDate="{{endDate}}" startDate="{{startDate}}" message="{{poll.suspensionMessage}}"></app-suspend-popup>
  <ng-template #ongoing>
    <div *ngIf="isValidated else notValidated">
      <div *ngIf="isTestModeActive && testHash != '' else noTestHash" class="text-center mb-5">
        <p class="dark-blue">
          <span class="bold">CHOIX ENREGISTRÉ </span>avec succès le <span class="bold">
            {{getCurrentFormattedDate()}}</span>
        </p>

        <p class="dark-blue no-margin text-sm bold text-left mt-20 w-90 margin-auto"><span>>_ </span>Expression de votre
          chiffré</p>
        <div class="test-hash-box w-90 margin-auto">
          <p class="dark-blue no-margin text-xs break-all">{{testHash}}</p>
        </div>

        <div class="content-between"
          [ngClass]="isMobile ? 'flex align-items-center flex-column gap-10' : 'flex flex-row'">
          <button [ngClass]="shouldDisplayTestBallot ? 'action-button-disabled' : 'action-button'"
            (click)="!shouldDisplayTestBallot && displayTestResult()">DÉCHIFFRER LE BULLETIN</button>
          <button class="action-button" (click)="resetWalkthrough()">RECOMMENCER UN TEST</button>
        </div>

        <div *ngIf="electionSelected != -1 && shouldDisplayTestBallot" class="margin-auto mt-20"
          id="test-results-container">

          <div id="list-results-container" class="flex-row ">
            <div class="flex-row align-items-center">
              <img src="assets/list-icon.svg" alt="list-icon" class="icon mr-10" width="40px">
              <div>
                <p class="no-margin dark-blue">{{electionSelected + 1}} <sup
                    style="top: -4px; left: -2px; font-size: 10px;">{{electionSelected === 0 ?
                    'ère' : 'ème'}}</sup> élection</p>

                <p class="no-margin dark-blue bold text-lg">
                  {{poll.rounds[electionSelected].title}}
                </p>
              </div>

            </div>
            <span class="play-triangle"></span>
            <div class="flex flex-row align-items-center gap-10">
              <img
                *ngIf="poll.rounds[electionSelected].displayedQuestions[0].listImages[testResults[0].indexOf(1)] != undefined && poll.rounds[electionSelected].displayedQuestions[0].listImages[testResults[0].indexOf(1)] !== ''"
                src="{{poll.rounds[electionSelected].displayedQuestions[0].listImages[testResults[0].indexOf(1)]}}"
                alt="list-icon" width="40px" class="icon mb-10">

              <p class="no-margin dark-blue bold text-lg">
                {{poll.rounds[electionSelected].questions[0].answers[testResults[0].indexOf(1)]}}
              </p>
            </div>
          </div>

          <div class="candidate-card flex-col p-20 w-full content-between mb-10">
            <div class="w-full" *ngFor="let candidate of testDisplayedCandidates; let i = index">
              <div class="flex-col">
                <div class="flex-row align-items-center mb-10">
                  <p class="no-margin dark-blue bold text-lg mr-10">{{i + 1}}.</p>
                  <img *ngIf="candidate.listImages[0] != undefined else noImage" src="{{candidate.listImages[0]}}"
                    alt="man-icon" class="icon mr-10" width="40px">
                  <ng-template #noImage>
                    <img *ngIf="candidate.name.startsWith('M.')" src="assets/man-icon.svg" alt="man-icon"
                      class="icon mr-10">
                    <img *ngIf="candidate.name.startsWith('Mme')" src="assets/woman-icon.svg" alt="woman-icon"
                      class="icon mr-10">
                  </ng-template>

                  <p class="no-margin dark-blue bold text-lg"
                    [ngStyle]="{'text-decoration': candidate.selected === false ? 'line-through' : 'none'}">
                    {{candidate.name}}</p>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="w-three-quarters margin-auto bg-yellow p-20 mt-20 text-left" style="border-radius: 10px;">
          <div class="flex-row align-items-center gap-10">
            <span class="exclamation dark-blue bold">!</span>
            <p class="dark-blue text-md no-margin"><span class="bold">Rassurez-vous </span>: Votre bulletin n'a pas été
              déposé dans l'urne.</p>

          </div>
        </div>
      </div>
      <ng-template #noTestHash>
        <div class="custom-accordion-container w-90 margin-auto"
          *ngIf="poll.description && poll.description.trim() !== '' && availableElections() && !isClosed">
          <div class="custom-accordion-item" (click)="toggleDescription()">
            <p class="text-md dark-blue custom-description" [class.expanded]="isDescriptionExpanded">
              {{isDescriptionExpanded ? poll.description : getTruncatedDescription()}}
            </p>
            <i class="pi pi-chevron-down custom-arrow" [class.rotated]="isDescriptionExpanded"></i>
          </div>
        </div>

        <app-list-election-choices
          *ngIf="electionSelected == -1 && availableElections() && !isClosed else noAvailableElections"
          [isMobile]="isMobile" [rounds]="poll?.rounds" [votedStatuses]="votedStatuses"
          (electionSelected)="setActiveElection($event)" [votingProof]="votingProof"></app-list-election-choices>

        <ng-template #noAvailableElections>
          <div *ngIf="isClosed" class="margin-auto w-three-quarters flex-col align-items-center">
            <img src="assets/voted-ko.svg" alt="v8te-icon" width="100px">
            <p class="dark-blue bold">Scrutin clôturé.</p>
            <p class="dark-blue text-center">Votre bulletin ne peut plus être déposé dans l’urne.</p>
          </div>
          <div *ngIf="status === PollStatus.alreadyVoted && !isClosed"
            class="margin-auto w-three-quarters flex-col align-items-center">
            <img src="assets/voted-ok.svg" alt="v8te-icon" width="100px">
            <p class="dark-blue bold">Vous avez déjà voté.</p>
            <p class="dark-blue text-center">{{errorMessage}}</p>
          </div>
          <div *ngIf="status === PollStatus.voted && !availableElections()"
            class="margin-auto w-three-quarters flex-col align-items-center">
            <img src="assets/voted-ok.svg" alt="v8te-icon" width="100px">
            <p class="dark-blue bold">Merci pour votre participation.</p>
            <p class="dark-blue text-center">Vos bulletins de vote ont été transmis aux urnes pour toutes les élections.
              Le processus de vote est désormais terminé.</p>
          </div>
        </ng-template>

        <app-list-choices *ngIf="electionSelected != -1 && listSelected == -1" [electionSelected]="electionSelected"
          [rounds]="poll?.rounds" [currentList]="currentList" (setActiveListEvent)="setActiveList($event)"
          (setActiveElectionEvent)="setActiveElection($event)" [isMobile]="isMobile"></app-list-choices>
        <app-candidate-choices *ngIf="listSelected != -1" [listSelected]="listSelected" [localAnswers]="localAnswers"
          [displayedCandidates]="displayedCandidates" [electionSelected]="electionSelected" [rounds]="poll?.rounds"
          [isVoteValid]="isVoteValid" [isLoading]="isLoadingCandidates" (confirmSelectionEvent)="votingPopup()"
          (setActiveListEvent)="setActiveList($event)" [isMobile]="isMobile"
          (setActiveCandidateEvent)="selectionHandler($event)"></app-candidate-choices>
      </ng-template>
    </div>
    <ng-template #notValidated>
      <div *ngIf="notYetOpen" class="margin-auto w-three-quarters flex-col align-items-center">
        <img src="assets/voted-ko.svg" alt="v8te-icon" width="100px">
        <p class="dark-blue bold">Scrutin pas encore ouvert.</p>
        <p class="dark-blue text-center">Le scrutin débutera le {{startDate}}</p>
      </div>
      <app-list-2fa  *ngIf="!notYetOpen" (sendCodeEvent)="validateSMS($event)" (sendSMSEvent)="resendSMS()" [phoneNumber]="userPhoneNumber"
        (sendPasswordEvent)="validatePassword($event)" [retries]="userRetriesRemaining"  [validationErrorObj]="validationErrorObj"
        [changeablePhone]="poll.phoneChangeable" [isValidationCodeError]="isValidationCodeError" [noMoreSMS]="noMoreSMS"
        [password]="poll.password" [validatedPassword]="isValidatedPass" [validatedSMS]="isValidatedSms"
        (sendPhoneEvent)="setupPhone($event)" [phoneChangeable]="poll.phoneChangeable"
        (sendSmsFirstEvent)="sendFirstSms()" [smsSent]="smsSent" [welcomeText]="poll.welcomeText"
        [isWrongPhoneError]="isWrongPhoneError">
      </app-list-2fa>
    </ng-template>
  </ng-template>

  <div class="footer flex content-center mt-30">
    <img src="assets/v8te.png" alt="v8te-icon" width="200px">
  </div>

  <app-warning-confirmation-popup *ngIf="validateVotePopup" [isTestModeActive]="isTestModeActive"
    (voteConfirmation)="validateVote($event)" [testDisplayedCandidates]="testDisplayedCandidates"
    [electionTitle]="poll?.rounds[electionSelected].title" [sha]="ballotSha"
    [listImage]="poll?.rounds[electionSelected].displayedQuestions[0].listImages[currentList]"
    [listName]="poll?.rounds[electionSelected].displayedQuestions[0].answers[currentList]"></app-warning-confirmation-popup>
  <app-vote-confirmation-popup *ngIf="displayHashPopup && hasLoadedPart" [isMobile]="isMobile" [hash]="voteHash" [rounds]="poll?.rounds"
    (voteConfirmation)="closeHashPopup($event)" [round]="activePoll.round"
    [votedStatuses]="votedStatuses"></app-vote-confirmation-popup>
  <!-- [electionName]="poll?.rounds[activePoll.round].title" [nextElectionName]="poll?.rounds[activePoll.round +1].title" -->

  <!-- <app-warning-popup id="new" *ngIf="validateVotePopup" title="{{'POLL-WARNING.CATCH' | translate}}"
    firstText="{{'POLL-WARNING.TITLE' | translate}}" [confirmButton]="true" [modifyButton]="true"
    (endDetailsPopup)="validateVote($event)"> </app-warning-popup> -->

  <div *ngIf="isVotingAnimation">
    <app-vote-animation [isMobile]="isMobile">
    </app-vote-animation>
  </div>

</div>
